import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Typography,
  IconButton,
  Dialog,
  Button,
  AppBar,
  Toolbar,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import Loading from '../common/loading';

const useStyles = makeStyles((theme) => ({
  iframe: {
    border: '0',
    height: '100%',
    width: '100%',
  },
  closeButton: {
    marginLeft: 'auto',
  }
}));

const FeedPreview = ({btnLabel, url}) => {
  const [open, setOpen] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
    setIframeLoaded(false);
  }

  return (
    <>
      <Button color="primary" onClick={() => setOpen(true)}>{btnLabel}</Button>
      <Dialog
        open={open}
        fullScreen
        onClose={handleClose}
      >
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6">
              Feed preview
            </Typography>
            <IconButton className={classes.closeButton} color="inherit" onClick={handleClose} aria-label={t('common:close')} title={t('common:close')}>
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        {iframeLoaded ? '' : <Loading />}
        <iframe className={classes.iframe} src={url} onLoad={() => setIframeLoaded(true)} title="Feed preview" />
      </Dialog>
    </>
  );
};

FeedPreview.propTypes = {
  btnLabel: PropTypes.string,
  url: PropTypes.string,
};

export default FeedPreview;
